import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const TrainingGroupList = ({ trainingGroups, selectedGroup, onGroupSelect }) => (
  <div className="rounded-lg bg-white shadow">
    <div className="border-b border-gray-200 px-6 py-4">
      <h3 className="text-lg font-medium text-gray-900">Available Training Groups</h3>
    </div>
    <div className="divide-y divide-gray-200">
      {trainingGroups.length === 0 ? (
        <div className="px-6 py-8 text-center">
          <p className="text-gray-500">No training groups available.</p>
        </div>
      ) : (
        trainingGroups.map((group) => (
          <div
            key={group.id}
            className={`cursor-pointer px-6 py-4 hover:bg-gray-50 ${
              selectedGroup === group.id ? 'border-l-4 border-blue-400 bg-blue-50' : ''
            }`}
            onClick={() => onGroupSelect(group.id)}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <UserGroupIcon className="h-8 w-8 text-gray-400" />
                </div>
                <div className="ml-4">
                  <h4 className="text-sm font-medium text-gray-900">{group.name}</h4>
                  <p className="text-sm text-gray-500">{group.description || 'No description'}</p>
                  <div className="mt-1 flex items-center space-x-4 text-xs text-gray-500">
                    <span>Type: {group.group_type}</span>
                    <span>Members: {group.member_count || 0}</span>
                  </div>
                </div>
              </div>
              {selectedGroup === group.id && (
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);

export default TrainingGroupList;
